import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react";

import { MyBetsStoreContext } from "@state/context/my-bets/MyBetsStoreContext";
import BetCombinationItem from "./BetCombinationItem";
import { MyBetsBetContext } from "@state/context/my-bets/MyBetsBetContext";

export default observer(function BetCombinationsBody() {
	const { t } = useTranslation("mybets");
	const bet = useContext(MyBetsBetContext);

	const store = useContext(MyBetsStoreContext);

	if (store == null) {
		return null;
	}

	const combinations = store.betCombinationsMap.get(bet.id);

	return (
		<div className="popup__body">
			<table className="table--primary">
				<thead className="table--primary__header table--primary__header--light">
					<tr className="table--primary__header__row">
						<th className="table--primary__header__data u-type--center">
							{t("ITEM.BET_SLIP_COMBINATIONS.ORDINAL_NUMBER")}
						</th>
						<th className="table--primary__header__data u-type--center">
							{t("ITEM.BET_SLIP_COMBINATIONS.COMBINATION")}
						</th>
						<th className="table--primary__header__data u-type--center">
							{t("ITEM.BET_SLIP_COMBINATIONS.TOTAL_QUOTA")}
						</th>
					</tr>
				</thead>
				<tbody className="table--primary__body">
					{combinations != null &&
						combinations.length > 0 &&
						combinations.map(
							(
								combination: {
									combinationStatus: number;
									combinationOffers: {
										systemIdentifier: string;
									}[];
									combinationQuota: number;
								},
								index: string
							) => (
								<BetCombinationItem
									combination={combination}
									key={index}
									ordinalNumber={index + 1}
								/>
							)
						)}
				</tbody>
			</table>
			<div className="u-mar--top--xsml">
				<div className="tag tag--base tag--bet--open u-display--ib u-mar--right--xsml">
					{t("ITEM.BET_SLIP_COMBINATIONS.OPEN")}
				</div>
				<div className="tag tag--base tag--bet--won u-display--ib u-mar--right--xsml">
					{t("ITEM.BET_SLIP_COMBINATIONS.WON")}
				</div>
				<div className="tag tag--base tag--bet--lost u-display--ib u-mar--right--xsml">
					{t("ITEM.BET_SLIP_COMBINATIONS.LOST")}
				</div>
				<div className="tag tag--base tag--bet--cancelled u-display--ib u-mar--right--xsml">
					{t("ITEM.BET_SLIP_COMBINATIONS.CANCELLED")}
				</div>
				<div className="tag tag--base tag--bet--returned u-display--ib u-mar--right--xsml">
					{t("ITEM.BET_SLIP_COMBINATIONS.RETURNED")}
				</div>
			</div>
		</div>
	);
});
